import React from 'react';
import './stageshow.css';

/**
 * Stageshow bento: four small product stills, each with one motion that has a cause.
 * Figures are real engine outputs (TX SaaS $99 -> $4.95, 6.25% on the taxable 80%; CA nexus $500,000; NE Eagle 1% -> 1.5% on Jan 1, 2027).
 */
const FeatureBento: React.FC<{ variant?: 'landing' | 'developers' }> = ({ variant = 'landing' }) => (
  <section className="ss-bento-band" aria-labelledby={`ss-bento-${variant}`} data-testid={`stageshow-bento-${variant}`}>
    <div className="container">
      <h2 id={`ss-bento-${variant}`}>{variant === 'developers' ? 'One engine, four ways in' : 'Everything sales tax, in one place'}</h2>
      <div className="ss-bgrid">
        <article className="ss-btile ss-btile-wide">
          <div className="ss-bcopy"><span className="ss-k">Checkout</span><h3>Tax on every line, before they pay</h3><p>Each line is taxed by what it is and where it ships.</p></div>
          <div className="ss-mini ss-mini-receipt" aria-hidden="true">
{variant === 'developers' ? (<>
            <div className="ss-line"><span>line_1 · SaaS · ship_to TX</span><span className="ss-num">amount 9900</span></div>
            <div className="ss-line ss-line-on ss-anim-in"><span>TX taxes 80% of SaaS</span><span className="ss-num">tax_amount 495</span></div>
            <div className="ss-line ss-line-total"><span>total</span><span className="ss-num">10395</span></div>
            </>) : (<>
            <div className="ss-line"><span>SaaS plan · Texas</span><span className="ss-num">$99.00</span></div>
            <div className="ss-line ss-line-on ss-anim-in"><span>Sales tax</span><span className="ss-num">$4.95</span></div>
            <div className="ss-line ss-line-total"><span>Total</span><span className="ss-num">$103.95</span></div>
            </>)}
          </div>
        </article>
        <article className="ss-btile">
          <div className="ss-bcopy"><span className="ss-k">Nexus</span><h3>Know before you owe</h3></div>
          <div className="ss-mini" aria-hidden="true">
            <div className="ss-line"><span><span className="ss-chip">CA</span>&nbsp; {variant === 'developers' ? 'threshold 500000' : '$500,000'}</span><span className="ss-pill">Within 20%</span></div>
            <div className="ss-line"><span className="ss-meter"><span className="ss-anim-fill" /></span></div>
          </div>
        </article>
        <article className="ss-btile">
          <div className="ss-bcopy"><span className="ss-k">Rule watch</span><h3>Changes, from the state’s own site</h3></div>
          <div className="ss-mini" aria-hidden="true">
            <div className="ss-line ss-line-on ss-anim-drop"><span><span className="ss-chip">NE</span>&nbsp; Eagle 1% → 1.5%</span><small>Jan 1</small></div>
            <div className="ss-line ss-line-mute"><b className="ss-bar" style={{ width: '60%' }} /></div>
          </div>
        </article>
        <article className="ss-btile ss-btile-wide ss-btile-dark">
          <div className="ss-bcopy"><span className="ss-k">API and MCP</span><h3>Built for your code and your agents</h3><p>REST for checkout, an MCP server for Grok Bot and ChatGPT.</p></div>
          <pre className="ss-term" aria-hidden="true"><code><span className="ss-t-dim">$</span> curl gotrutax.com/api/v1/public/calculate{'\n'}<span className="ss-t-ok ss-anim-type">{'{ "tax_amount": 495 }'}</span></code></pre>
        </article>
      </div>
    </div>
  </section>
);

export default FeatureBento;
